<template>
  <div class="discount-list">
    <div v-for="(item, index) in innerValue" :key="index" class="discount-card">
      <div class="discount-card__header">
        <span class="title">{{ $t('views.wheeloffortune.pop.text_629862635238') }}{{ index + 1 }}</span>
        <span class="ops">
          <el-button v-if="index !== 0" type="text" @click="remove(index)">
            <i class="el-icon-delete"></i>
            {{ $t('views.wheeloffortune.pop.text_52209664') }}
          </el-button>
        </span>
      </div>

      <div class="wheel-setting-item">
        <p class="wheel-setting-field">{{ $t('views.wheeloffortune.pop.text_63d0793a') }}</p>
        <el-input
          v-model="item.couponPrompt"
          @change="emitChange"
          placeholder="Your discount code is"
          autosize
          class="class-input"
          show-word-limit
          maxlength="60"
        />
      </div>

      <div class="wheel-setting-item">
        <p class="wheel-setting-field">{{ $t('views.wheeloffortune.pop.text_6298626378018bbe') }}</p>
        <div class="el-form-item wheel-setting-item col-10" style="margin: 0;">
          <el-select v-model="item.discountType" @change="emitChange" :placeholder="$t('views.wheeloffortune.pop.text_8bf7900962e9')">
            <span v-if="item.discountType === 'dongtai'" slot="prefix" style="padding-left: 2px; font-size: 18px; height: 100%; display: inline-flex; align-items: center;">
              <el-tooltip class="item" popper-class="discount-pop" effect="light" :content="$t('views.wheeloffortune.pop.text_62114eec5c064e3a')" placement="bottom-start">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </span>
            <el-option
              v-for="opt in selectOptions"
              :key="opt.value"
              :label="opt.name"
              :value="opt.value"
            >
              <div>
                <span
                  v-if="opt.value === 'dongtai'"
                  style="padding-left: 2px; color: #C5C4CE; font-size: 18px; height: 100%; display: inline-flex; align-items: center; vertical-align: text-top;"
                >
                  <el-tooltip class="item" popper-class="discount-pop" effect="light" :content="$t('views.wheeloffortune.pop.text_62114eec5c064e3a')" placement="bottom-start">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </span>
                {{ opt.name }}
              </div>
            </el-option>
          </el-select>
        </div>
      </div>

      <div v-if="item.discountType === 'dongtai'" class="wheel-setting-item col-10">
        <el-button type="text" @click="$emit('set-dynamic', index)">{{ $t('views.wheeloffortune.setting.discountsetting.set-discount-code') }}<i class="el-icon-arrow-right"></i></el-button>
      </div>

      <div v-if="item.discountType === 'guding'" class="wheel-setting-item">
        <p class="wheel-setting-field">{{ $t('views.wheeloffortune.pop.text_629862637801') }}</p>
        <div class="el-form-item wheel-setting-item" :class="item.couponCode ? '' : 'is-error'">
          <el-input
            class="wheel-setting-collapse-input-coupon class-input"
            v-model="item.couponCode"
            @change="emitChange"
            maxlength="30"
            show-word-limit
            autosize
            :placeholder="$t('views.wheeloffortune.pop.stylesetting.discountlist.coupon-code-placeholder')"
          />
        </div>
      </div>
    </div>

    <div v-if="innerValue.length < max" class="discount-add">
      <el-button type="text" @click="add">
        <i class="el-icon-plus"></i>
        {{ $t('views.wheeloffortune.pop.stylesetting.discountlist.add-coupon') }}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiscountList',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    max: {
      type: Number,
      default: 20
    },
    triggerEventType: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      innerValue: []
    }
  },
  computed: {
    selectOptions() {
      const base = [{ name: this.$t('views.wheeloffortune.pop.text_56fa5b9a62986263'), value: 'guding' }]
      return base
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(v) {
        // 避免循环更新：只在数据真正不同时更新
        const newData = (v || []).map(it => ({
          couponPrompt: it.couponPrompt || '',
          discountType: it.discountType || 'guding',
          couponCode: it.couponCode || ''
        }))
        
        // 比较新旧数据是否真的不同
        if (JSON.stringify(newData) !== JSON.stringify(this.innerValue)) {
          this.innerValue = newData
        }
      }
    }
  },
  mounted() {
    // Component mounted
  },
  methods: {
    add() {
      if (this.innerValue.length >= this.max) return
      this.innerValue.push({
        couponPrompt: '',
        discountType: 'guding',
        couponCode: ''
      })
      this.emitChange()
    },
    remove(i) {
      this.innerValue.splice(i, 1)
      this.emitChange()
    },
    emitChange() {
      this.$emit('input', this.innerValue)
      this.$emit('change', this.innerValue)
    }
  }
}
</script>

<style scoped>
.discount-card {
  border: 1px solid #E4E3EB;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 12px;
  padding: 0 12px;
}
.discount-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #F6F5FF;
  height: 45px;
  line-height: 45px;
  padding: 0 12px;
  margin: 0 -12px 12px;
}
.discount-card__header .title {
  color: #5a54f9;
  font-weight: 600;
}
.discount-add {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
}
.limit-tip { color: #C5C4CE; }
</style>
